import { useState } from "react";
import axios from "axios";

export function ChatGpt() {
  const [text, setText] = useState("");
  const [correctedText, setCorrectedText] = useState("");
  const [errors, setErrors] = useState([]);
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [wordCount, setWordCount] = useState(0);
  const [sentenceCount, setSentenceCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState("Without Countdown Timer");
  const [textInput, setTextInput] = useState("");

  const YOUR_OPENAI_API_KEY = 'Bearer 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';
  const handleRadioChange = (e) => setSelectedOption(e.target.value);
  const handleTextInputChange = (e) => setTextInput(e.target.value);
  const handleGrammarCheck = async () => {
    if (!text.trim()) {
      alert("Please enter some text to check.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4o-mini",
          messages: [
            { 
              role: "user", 
              content: `Analyze the following text for grammar, spelling, and clarity: "${text}".
              Provide a JSON response with:
              - "corrected_text": The corrected version of the text.
              - "errors": A list of objects containing "wrong_word" (incorrect word) and "suggestion" (correction).
              - "score": A number from 0-10 representing the grammar and spelling quality.
              - "character_count": The total number of characters in the text.
              - "word_count": The total number of words in the text.
              - "sentence_count": The total number of sentences in the text.

              Respond in JSON format like this:
              {
                "corrected_text": "your_corrected_text_here",
                "errors": [
                  { "wrong_word": "wrongWord1", "suggestion": "correctWord1" },
                  { "wrong_word": "wrongWord2", "suggestion": "correctWord2" }
                ],
                "score": your_score_here,
                "character_count": character_count_here,
                "word_count": word_count_here,
                "sentence_count": sentence_count_here
              }`
            }
          ],
          temperature: 0.5,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: YOUR_OPENAI_API_KEY,
          },
        }
      );

      const responseData = JSON.parse(response.data.choices[0].message.content.trim());

      setCorrectedText(responseData.corrected_text); // Corrected Text
      setErrors(responseData.errors); // Grammar & Spelling Errors
      setScore(responseData.score); // Grammar Score
      setCharCount(responseData.character_count); // Character Count
      setWordCount(responseData.word_count); // Word Count
      setSentenceCount(responseData.sentence_count); // Sentence Count
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong! Please try again.");
    }
    setLoading(false);
  };

  const handlePrint = () => window.print();
  const handleSave = () => alert("Essay saved successfully!");

  return (
    <section className="custom-sign write-essay">
    <div className="container">
     {/* Buttons */}
     <div className="write-essay-buttons" style={{ display: "flex", gap: "10px" }}>
          <button onClick={handleGrammarCheck} disabled={loading}>{loading ? "Checking..." : "Grammar & Spell Checker"}</button>
          <button onClick={handlePrint}>Print</button>
          <button onClick={handleSave}>Save</button>
        </div>
        {/* Radio Buttons in a Single Row */}
        <div className="write-essay-radio" style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
        <label>
            <input
              type="radio"
              name="timerOption"
              value="Without Countdown Timer"
              checked={selectedOption === "Without Countdown Timer"}
              onChange={handleRadioChange}
              style={{ marginRight: "5px" }}
            />
            Without Countdown Timer
          </label>
          <label>
            <input
              type="radio"
              name="timerOption"
              value="With Countdown Timer"
              checked={selectedOption === "With Countdown Timer"}
              onChange={handleRadioChange}
              style={{ marginRight: "5px" }}
            />
            With Countdown Timer
          </label>
          
        </div>
        {/* Title Input */}

        <div className="write-essay-title-input">
        <input
          type="text"
          placeholder="Type title here"
          value={textInput}
          onChange={handleTextInputChange}
          style={{ width: "100%", padding: "8px", display: "block" }}
        />
        </div>
      {/* Textarea Input */}
      <div className="like-writer-textarea" style={{ marginBottom: "10px" }}>
      <textarea
        placeholder="Type or paste your text here..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows="5"
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      ></textarea>
      </div>

      {/* Buttons */}
      {/* <div style={{ display: "flex", gap: "10px" }}>
        <button onClick={handleGrammarCheck} disabled={loading}>
          {loading ? "Checking..." : "Grammar & Spell Checker"}
        </button>
      </div> */}

      {/* Corrected Output */}
      {correctedText && (
        <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f8f8f8" }}>
          <h3>Corrected Text:</h3>
          <p>{correctedText}</p>
        </div>
      )}

      {/* Errors Display */}
      {errors.length > 0 && (
        <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#ffe6e6" }}>
          <h3>Errors:</h3>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>
                <strong>Wrong:</strong> {error.wrong_word} → <strong>Correct:</strong> {error.suggestion}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Score Display */}
      {score !== null && (
        <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#e6f7e6" }}>
          <h3>Score: {score}/10</h3>
        </div>
      )}

      {/* Text Statistics */}
      <div className="write-essay-count" style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <p><strong>Character Count:</strong> {charCount}</p>
        <p><strong>Word Count:</strong> {wordCount}</p>
        <p><strong>Sentence Count:</strong> {sentenceCount} </p>
      </div>
      <div className="write-essay-grammar-spelling-issue" style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <p><strong>2</strong> Grammar & Spelling issues</p>
       
      </div>
      {/* <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <h3>Text Statistics:</h3>
        <p><strong>Characters:</strong> {charCount}</p>
        <p><strong>Words:</strong> {wordCount}</p>
        <p><strong>Sentences:</strong> {sentenceCount}</p>
      </div> */}
    </div>
    </section>
  );
}
